module.exports = __webpack_public_path__ + "static/media/profile2.87724133.png";